module.exports = __webpack_public_path__ + "img/9788937832970.06f5af24.jpg";